var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Applications")]),_c('WorkerApplications',{staticClass:"mb-4"}),_c('h1',[_vm._v("Timesheets")]),_c('WorkerTimesheets')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }